import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../config.service';
import { ApiService } from '../shared';

@Injectable()
export class CompaniesService {
    static currentCompany: any;
    private serviceUrl = ConfigService.serviceUrl;
    companies: any[];

    constructor (private http: Http) {

    }

    private extractData(res: Response) {
      let body = res.json();
      return body;
    }

    private handleError (error: Response | any) {
      let errMsg: string;
      if (error instanceof Response) {
        const body = error.json() || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      } else {
        errMsg = error.message ? error.message : error.toString();
      }
      console.error(errMsg);
      return Observable.throw(errMsg);
    }

    getCompanies (): Observable<any[]> {
        return this.http.get(`${this.serviceUrl}/companies`)
          .map(this.extractData)
          .catch(this.handleError);
    }

    createCompany (company: any): Observable<any[]> {
      return Observable.create(observer => {
        if (company.name) {
          this.http.post(`${this.serviceUrl}/companies`, company).subscribe(resp => {
            let newCompany = this.extractData(resp);
            if (this.companies) {
              this.companies.push(newCompany);
              this.companies.sort((a, b) => {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                  return 1;
                }
                return -1;
              });
            }
            observer.next(newCompany);
            observer.complete();
           }, error => {
             observer.error(this.handleError(error));
             observer.complete();
           });
        } else {
          observer.error();
          observer.complete();
        }
      });
    }

    editCompany (company: any): Observable<any[]> {
      return Observable.create(observer => {
        if (company.name) {
          this.http.put(`${this.serviceUrl}/companies/` + company.id, company).subscribe(resp => {
            let newCompany = this.extractData(resp);
            if (this.companies) {
              this.companies.map(it => {
                if (it.id === newCompany.id) {
                  it.name = newCompany.name;
                }
              });
              this.companies.sort((a, b) => {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                  return 1;
                }
                return -1;
              });
            }
            observer.next(newCompany);
            observer.complete();
           }, error => {
             observer.error(this.handleError(error));
             observer.complete();
           });
        } else {
          observer.error();
          observer.complete();
        }
      });
    }

    getEmployers(): Observable<any> {
    if (this.companies) {
      return Observable.create(observer => {
        observer.next(this.companies);
        observer.complete();
      });
    } else {
      return Observable.create(observer => {
        this.getCompanies().subscribe(employers => {
          employers.sort((a, b) => {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return -1;
          });
          this.companies = employers;
          observer.next(this.companies);
          observer.complete();
        });
      });
    }
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  saveItemsPerPage(value: number) {
    ApiService.saveItemsPerPage(value);
  };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/companies/companies.service.ts